import "../css/TwoColumnsText.css";
import { useState, Suspense, lazy } from "react";
import { Flex, Row, Col } from "antd";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import { useQuery } from "@apollo/client";
import {
  GET_TWO_COLUMS_TEXT_BY_SLUG,
} from "../queries";


const compPosition = (comp, contenidoDerecha, contenidoIzquierda) => {
  let compPosition = ''
  if (comp) {
    if (comp === 'Accordion') {
      if (contenidoIzquierda.includes('<card')) {
        compPosition = 'left'        
      } else if (contenidoDerecha.includes('<card')) {
        compPosition = 'right'
      }
    } else if (comp === 'Contact') {
      if (contenidoIzquierda) {
        compPosition = 'right'
      } else if (contenidoDerecha) {
        compPosition = 'left'
      }
    }
  }
  return compPosition
}

const componentMap = {
  Accordion: lazy(() => import("./Accordion/Card")),
  Contact: lazy(() => import("../components/Forms/Contact")),
};

const TwoColumnsText = ({ page, section, comp, lang }) => {  
  const slug = `${page}-${section}-${lang}`;
  const DynamicComponent = comp && componentMap[comp];
  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });

  const isHero = section.includes('hero');

  const { loading, error, data } = useQuery(GET_TWO_COLUMS_TEXT_BY_SLUG, {
    variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {
      const postData = fetchedData.sectionsBy?.twocolumnstext;
      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      };
      
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  });  
  const positionComponent = compPosition(comp, sectionData?.contenidoDerecha, sectionData?.contenidoIzquierda)
  
  return (
    <>
    {
      sectionData && (
        <Flex className="TwoColumnsText">
        {sectionData?.tituloTct && (
          <Row>
            <Col span={24}>
              <Flex  className="TwoColumnsText-title">
                <Flex vertical>
                  <h2
                    className="h4-headline-500"
                    dangerouslySetInnerHTML={{ __html: sectionData?.tituloTct }}
                  />
                </Flex>
              </Flex>
            </Col>
          </Row>
        )}
          <Row justify={'space-between'} gutter={32} className="TwoColumnsText-content">
            <Col lg={12} md={24} xs={24} sm={24}>
              { (comp && positionComponent === 'left') ? (
                <Suspense fallback={<div>Loading...</div>}>
                  <DynamicComponent classStyle="TwoColumnsText-box TwoColumnsText-text" data={sectionData?.contenidoIzquierda} lang={lang}/>
                </Suspense>
              ) : (
                <Flex className="TwoColumnsText-box TwoColumnsText-text"
                  style={{
                    background: '#fff',
                  }}
                >
                  <div 
                    className='b2-body-400'
                    dangerouslySetInnerHTML={{ __html: sectionData?.contenidoIzquierda }}
                  />
                </Flex>
              )}
            </Col>
            <Col lg={12} md={24} xs={24} sm={24}>
              {(comp && positionComponent === 'right') ? (
                <Suspense fallback={<div>Loading...</div>}>
                  <DynamicComponent classStyle="TwoColumnsText-box TwoColumnsText-text" data={sectionData?.contenidoDerecha} lang={lang}/>
                </Suspense>
              ) : (
                <Flex className="TwoColumnsText-box TwoColumnsText-text"
                  style={{
                    background: '#fff',
                  }}
                >
                  <div 
                    style={{
                      lineHeight: '120%'
                    }}
                    className='b2-body-400'
                    dangerouslySetInnerHTML={{ __html: sectionData?.contenidoDerecha }}
                  />
                </Flex>
              )}
            </Col>
          </Row>
        </Flex>
      )
    }
    </>
  );
};

export default TwoColumnsText;
